import { render, staticRenderFns } from "./ButtonTapWithIcon.vue?vue&type=template&id=b15daeca&scoped=true&"
import script from "./ButtonTapWithIcon.vue?vue&type=script&lang=js&"
export * from "./ButtonTapWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTapWithIcon.vue?vue&type=style&index=0&id=b15daeca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15daeca",
  null
  
)

export default component.exports